import React from 'react';
import { chipPngUrl } from '../utils/blackjack/chipVisual';

/**
 * GS Radio chip from `public/media/chip*.png` (per denomination).
 * @param {number} value
 * @param {string} [className]
 * @param {React.CSSProperties} [style]
 */
export default function GsRadioChipPng({ value, className = '', style = {} }) {
  return (
    <span className={className.trim()} style={style} aria-hidden>
      <img src={chipPngUrl(value)} alt="" className="gs-radio-chip-png" draggable={false} />
    </span>
  );
}
